import { clientAppSettings } from '../Models/ClientAppSettings';

export class Environment {
    /**
    * Get the base Azure portal Url (no trailing /).
    */
    public static azurePortalUrl(): string {
        const env = (clientAppSettings.environment).toLowerCase();
        switch (env) {
            case "scratch":
            case "ppe":
            default:
                return "https://portal.azure.com";
            case "usgovppe":
            case "usgovprd":
                return "https://portal.azure.us";
        }
    }

    /**
     * Get the url to create a new bot in Azure.
     */
    public static azureCreateBotUrl(): string {
        const env = (clientAppSettings.environment || 'prod').toLowerCase();
        switch (env) {
            case "scratch":
            case "ppe":
                return "https://portal.azure.com/#create/Microsoft.AzureBot";
            case "usgovppe":
            case "usgovprd":
                return "https://portal.azure.us/#create/Microsoft.AzureBot";
            case "cnppe":
            case "cnprd":
                return "https://portal.azure.cn/#create/Microsoft.AzureBot";
            default:
                return "https://portal.azure.com/#create/Microsoft.AzureBot";
        }
    }

     /**
    * Get the current portal environment.
    */
    public static portalEnvironment(): string {   
       return (clientAppSettings.environment).toLowerCase();    
    }
}



// WEBPACK FOOTER //
// ./Client/Utils/Environment.ts